module.exports = __webpack_public_path__ + "img/offerImage.c6d05552.png";